import { render, staticRenderFns } from "./DealsPage.vue?vue&type=template&id=9342e0f4&lang=pug&"
import script from "./DealsPage.vue?vue&type=script&lang=js&"
export * from "./DealsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports